const EndPoints = {
  states: "https://api.houmti.io/v1/states",
  cities: "https://api.houmti.io/v1/cities",

  getHome: "https://api.houmti.io/v1/get-home",
  createPost: "https://api.houmti.io/v1/create-post",
  postDetail: "https://api.houmti.io/v1/post-details",
  deletePost: "https://api.houmti.io/v1/delete-post",
  updatePost: "https://api.houmti.io/v1/update-post",
  likePost: "https://api.houmti.io/v1/like-post",
  bookmarkPost: "https://api.houmti.io/v1/bookmark-post",
  hidePost: "https://api.houmti.io/v1/hide-post",
  myBookmarks: "https://api.houmti.io/v1/my-bookmarks",
  myPosts: "https://api.houmti.io/v1/my-posts",
  hiddenPosts: "https://api.houmti.io/v1/hidden-posts",
  comments: "https://api.houmti.io/v1/comments-list",
  commentOnPost: "https://api.houmti.io/v1/comment",
  likeComment: "https://api.houmti.io/v1/like-comment",
  getSales: "https://api.houmti.io/v1/get-sales",
  saleCategoris: "https://api.houmti.io/v1/sales-categories",

  myGroups: "https://api.houmti.io/v1/my-groups",
  nearbyGroups: "https://api.houmti.io/v1/groups-near-you",
  joinGroup: "https://api.houmti.io/v1/join-group",
  createGroup: "https://api.houmti.io/v1/create-group",
  updateGroup: "https://api.houmti.io/v1/edit-group",
  groupDetail: "https://api.houmti.io/v1/group-details",
  getGroupPosts: "https://api.houmti.io/v1/get-group-posts",
  createGroupPost: "https://api.houmti.io/v1/create-group-post",
  updateGroupPost: "https://api.houmti.io/v1/edit-group-post",
  leaveGroup: "https://api.houmti.io/v1/exit-group",
  deleteGroup: "https://api.houmti.io/v1/delete-group",
  groupMembers: "https://api.houmti.io/v1/get-group-members",
  addMember: "https://api.houmti.io/v1/add-group-member",
  removeMember: "https://api.houmti.io/v1/remove-group-member",
  removeAdmin: "https://api.houmti.io/v1/remove-group-admin",
  makeAdmin: "https://api.houmti.io/v1/make-group-admin",
  rejectMember: "https://api.houmti.io/v1/reject-member-request",

  businessCategoris: "https://api.houmti.io/v1/business-categories",
  createBusinessPost: "https://api.houmti.io/v1/create-business-post",
  editBusinessPost: "https://api.houmti.io/v1/edit-business-post",
  deleteBusinessPost: "https://api.houmti.io/v1/delete-business-post",
  businessPosts: "https://api.houmti.io/v1/business-posts",
  businessPostDetail: "https://api.houmti.io/v1/business-post-details",
  commentOnBusinessPost: "https://api.houmti.io/v1/comment-business-post",
  businessPostComments: "https://api.houmti.io/v1/comments-list-business",

  notifications: "https://api.houmti.io/v1/notifications",
  notificationsCount: "https://api.houmti.io/v1/notifications-unseen-count",
  readNotification: "https://api.houmti.io/v1/read-notification",
  contacts: "https://api.houmti.io/v1/contacts",
  contactUs: "https://api.houmti.io/v1/contact-us",

  editProfile: "https://api.houmti.io/v1/edit-profile",
  reportPost: "https://api.houmti.io/v1/report-a-post",
  reportComment: "https://api.houmti.io/v1/report-a-comment"
};

export default EndPoints;
